import React from "react";
import { LANGUAGES } from "../../../../../../utils/constants";
import CodeEditor from "../../../../../../components/elements/CodeEditor";
import CustomSelect from "../../../../../../components/elements/CustomSelect";

export default function CodeLanguageEditor({ language, value, onChange }) {

    const handleLanguageChange = (e) => {
        const newLang = e.target.value; // ✅ FIX

        onChange({
            ...value,
            config: {
                ...value.config,
                language: newLang
            }
        });
    };

    const handleCodeChange = (newCode) => {
        onChange({
            ...value,
            config: {
                ...value.config,
                code: newCode
            }
        });
    };

    return (
        <div className='flex flex-col gap-8 p-5 bg-gray-200 rounded-lg'>
            <CustomSelect
                value={language}
                options={LANGUAGES}
                onChange={handleLanguageChange}
            />

            <CodeEditor
                value={value?.config?.code || ""}
                language={language}
                onChange={handleCodeChange}
            />
        </div>
    );
}
